/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { access_token_token } from '../models/access_token_token';
import type { cluster_public_access_url } from '../models/cluster_public_access_url';
import type { cluster_public_http_api_url } from '../models/cluster_public_http_api_url';
import type { hls_id } from '../models/hls_id';
import type { HLSDetailsDto } from '../models/HLSDetailsDto';
import type { HLSForNew } from '../models/HLSForNew';
import type { limit } from '../models/limit';
import type { offset } from '../models/offset';
import type { sortOder } from '../models/sortOder';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HlsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any HLS Created
     * @throws ApiError
     */
    public hlsControllerPostHls({
        requestBody,
    }: {
        requestBody: HLSForNew,
    }): CancelablePromise<{
        ressource_id: number;
        cluster_http_api_url: cluster_public_http_api_url;
        cluster_public_access_url: cluster_public_access_url;
        download_path: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/HLS',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Wrong syntax.`,
                404: `Session not found.`,
                409: `Provided session is not started`,
                429: `Not enough ressources.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns any HLSs list
     * @throws ApiError
     */
    public hlsControllerGetHlsList({
        sessionIds,
        offset,
        limit,
        sort,
        descriptionLike,
        sessionStatus,
    }: {
        /**
         * Array of session ids
         */
        sessionIds?: Array<number>,
        offset?: offset,
        limit?: limit,
        /**
         * Sort criteria. properties to sort on with 'ASC' or 'DESC' as value.
         */
        sort?: {
            created_at?: sortOder;
        },
        /**
         * Filter HLSs on description containing a specific value.
         */
        descriptionLike?: string,
        sessionStatus?: 'pending' | 'provisioned' | 'active' | 'finished',
    }): CancelablePromise<{
        items: Array<HLSDetailsDto>;
        total: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/HLS',
            query: {
                'session_ids': sessionIds,
                'offset': offset,
                'limit': limit,
                'sort': sort,
                'description_like': descriptionLike,
                'session_status': sessionStatus,
            },
        });
    }
    /**
     * @returns HLSDetailsDto HLS info.
     * @throws ApiError
     */
    public hlsControllerGetHls({
        id,
    }: {
        /**
         * Id of the HLS production to get info about.
         */
        id: hls_id,
    }): CancelablePromise<HLSDetailsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/HLS/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `Not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns any retrieve resources to access live stream.
     * @throws ApiError
     */
    public hlsControllerGetHlsDownloadLink({
        id,
    }: {
        /**
         * Id of the HLS production to get its download link.
         */
        id: hls_id,
    }): CancelablePromise<{
        access_token: access_token_token;
        cluster_base_url: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/HLS/{id}/download_link',
            path: {
                'id': id,
            },
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `Not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public hlsControllerPostHlsStop({
        id,
    }: {
        /**
         * Id of the HLS production to stop.
         */
        id: hls_id,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/HLS/{id}/stop',
            path: {
                'id': id,
            },
            errors: {
                409: `Conflict`,
                500: `Internal error.`,
            },
        });
    }
}
